'use strict';

/* global $ */
/* global _ */
/* global Backbone */
/* global Marionette */

import { fancybox } from '../../../utils/params';

/**
 * Базовый класс для калькуляторов
 */
class CalculatorBaseView extends Marionette.View {
    modelEvents() {
        return {
            'calculator:added:to:basket' : 'showNotification',
            'change:is_progress': 'checkIsLoading'
        };
    }
    ui() {
        return {
            'image': '.js-calculator__image',
            'params': '.js-calculator__params',
            'buy': '.js-calculator__summary-button'
        };
    }
    regions() {
        return {
            'image': '@ui.image',
            'params': '@ui.params',
            'buy': '@ui.buy'
        };
    }
    childViewEvents() {
        return {
            'collection:changed': 'paramsCollectionChanged',
            'addToBasket:view': 'addToBasket'
        };
    }
    checkIsLoading(){
        let self = this;
        if(self.model.get('is_progress')){
            self.$el.addClass('is-loading');
        }else{
            self.$el.removeClass('is-loading');
        }
    }
    addToBasket() {
        let self = this;
        self.model.addToBasket();
    }
    showNotification() {
        let self = this;

        let popup_template = _.template($('#tpl-calculator__popup').html());

        var width = 500;
        $.fancybox(
            $.extend(true,
                { },
                fancybox,
                {
                    closeBtn: false,
                    maxWidth: width,
                    padding: 30,
                    content: popup_template({ name: self.model.get('name') }),
                }
            )
        );
        var selector = '.alfales-fancy .fancybox-inner';
        $(selector).on('click', '.js-popup-close', function(){ $.fancybox.close(); });
    }
}

export {
    CalculatorBaseView
};

